<template>
  <div class="searchbox">
    <div class="title">
      <b @click="get(1)" :style="{'border-bottom':index == 1 ? '2px solid #244991':'none'}">证书查询</b>
      <b @click="get(2)" :style="{'border-bottom':index == 2 ? '2px solid #244991':'none'}" style="margin-left: 30px">IATF 16949证书查询</b>
    </div>
    <div class="flex" v-if="index == 1">
      <div class="flex_item">
        <div class="flex">
          <span>证书号：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.apicertno"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>企业名称：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.apiepname"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>证书类别：</span>
          <!--                <div class="flex_item"><input type="text" placeholder="必填"></div>-->
          <div class="flex_item">
            <div class="option">
              <select v-model="query.apicerttype" >
                <option :value="item.code" :label="item.name" v-for="item in types" :key="item.id">请选择证书类别</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="flex_item" v-if="$store.state.stations.id != 1004">
        <div class="flex">
          <span>验证码：</span>
          <div class="flex_item"><input type="text" placeholder="必填" v-model="query.code"></div>
        </div>
      </div>
      <div v-if="$store.state.stations.id != 1004">
        <img style="margin-left: 0;width: 100px;height: 50px" :src="codeUrl" class="code"  @click="getCode"/>
      </div>
    </div>
    <div class="flex" v-if="index == 2">
      <div class="flex_item">
        <div class="flex">
          <span>证书号：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.apicertno"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>企业名称：</span>
          <div class="flex_item"><input type="text" placeholder="" v-model="query.apiepname"></div>
        </div>
      </div>
      <div class="flex_item">
        <div class="flex">
          <span>证书类型：</span>
          <!--                <div class="flex_item"><input type="text" placeholder="必填"></div>-->
          <div class="flex_item">
            <div class="option">
              <select v-model="query.apicerttype" >
                <option :value="item.code" :label="item.name" v-for="item in types2" :key="item.id">请选择证书类型</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="flex_item" v-if="$store.state.stations.id != 1004">
        <div class="flex">
          <span>验证码：</span>
          <div class="flex_item"><input type="text" placeholder="必填" v-model="query.code"></div>
        </div>
      </div>
      <div v-if="$store.state.stations.id != 1004">
        <img style="margin-left: 0;width: 100px;height: 50px" :src="codeUrl" class="code"  @click="getCode"/>
      </div>
    </div>
    <button type="button" class="btn" @click="submitQuery">查询</button>
  </div>
</template>

<script>

import {getCaptcha} from "@/network/api";

export default {
  name: "certification",
  data(){
    return {
      codeUrl:'',
      uuid:'',
      query:{
        apicertno:"",
        apiepname:"",
        apicerttype:0,
        code:'',
        uuid:'',
        index:1
      },
      types:[],
      types2:[],
      index:1
    }
  },
  created() {
    //获取中联分类数据
    this.getTypes();
  },
  mounted() {
    this.getCode()
    this.getTypes();
  },
  methods:{
    async getTypes(){
      let res = await this.$api.getCertTypes({});
      this.types = res.data.data
      this.types.unshift({
        id:0,
        name:""
      })

      let res2 = await this.$api.getCertTypes2({});
      this.types2 = res2.data.data
      this.types2.unshift({
        id:0,
        name:""
      })
    },
    submitQuery(){
      if(this.index == 1){
        if(!this.query.apicertno.trim()){
          return this.$msgbox('请输入证书号','提示')
        }
        if(!this.query.apiepname.trim()){
          return this.$msgbox('请输入企业名称','提示')
        }
        if(!this.query.apicerttype){
          return this.$msgbox('请选择证书类别','提示')
        }
      }else{
        if (!this.query.apicertno?.trim()){
          return this.$msgbox('请填写证书号', '提示');
        }
        const name = this.query.apiepname?.trim();

        if (!name) {
          return this.$msgbox('请填写企业名称', '提示');
        }

        if (!/^\p{Script=Han}{4,}$/u.test(name)) {
          return this.$msgbox('企业名称必须为汉字，且至少4个字', '提示');
        }
      }
      if(!this.query.code){
        return this.$msgbox('请先输入验证码','提示')
      }
      this.$emit("zlQueryClick",this.query)
    },
    async getCode(){
      let res = await this.$api.getCaptcha({});
      console.log(res)
      this.codeUrl = "data:image/gif;base64," + res.data.data.img;
      this.query.uuid = res.data.data.uuid
    },
    get(e){
      this.query = {
        apicertno:"",
        apiepname:"",
        apicerttype:0,
        code:'',
        uuid:'',
        index:1
      }
      this.getCode()
      this.query.index = e
      this.index = e
      this.$emit("qh")
    }
  }
}
</script>

<style scoped>

</style>
